export default __webpack_public_path__ + "static/media/IMG_192_9_copy.528645f5.jpg";